import { render, staticRenderFns } from "./OrganizationTable2.vue?vue&type=template&id=257d3104"
import script from "./OrganizationTable2.vue?vue&type=script&lang=ts"
export * from "./OrganizationTable2.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationTable2.vue?vue&type=style&index=0&id=257d3104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports